module.exports = __webpack_public_path__ + "img/how-it-works-3.283bcd59.svg";